import React, { useEffect, useState } from "react";
import ProductTable from "./products/components/ProductTable";
import EditProduct from "./EditProduct";
import DeleteProducts from "./products/deleteproduct/DeleteProducts";
import EditMenu from "./EditMenu";
import AddProductModal from "./products/components/AddProductModal";
import ProductToolbar from "./products/components/ProductToolbar";
import { useProductHandlers } from "./products/hooks/useProductHandlers";
import "./Edit.css";
import { PageTitle } from "src/shared/PageTitle";
import LoadingScreen from "src/shared/components/LoadingScreen";

const ProductsPage: React.FC = () => {
  const [businessType, setBusinessType] = useState<string>("");

  useEffect(() => {
    document.title = "Products › Settings › iMetanic";
    const storedBusinessType = sessionStorage.getItem("business_type");
    if (storedBusinessType) setBusinessType(storedBusinessType);
  }, []);

  const {
    products,
    categories,
    staff,
    totalRecords,
    loading,
    selectedProduct,
    showAddModal,
    showEditModal,
    showDeleteModal,
    searchTerm,
    categoryFilter,
    showDeletedProducts,
    page,
    rowsPerPage,
    refetchProducts,
    setShowAddModal,
    handleAddProduct,
    handleEditProduct,
    handleDeleteProduct,
    handleCloseModals,
    handleCategoryChange,
    handleToggleDeleted,
    handleSearchChange,
    handlePageChange,
    handleRowsPerPageChange,
  } = useProductHandlers({ businessType });

  const menu = { Product: "product" };

  return (
    <div>
      <div className="setting-overall-container">
        <PageTitle title="- Settings › Products" />
        <EditMenu editmenu={menu} />

        <ProductToolbar
          categories={categories}
          categoryFilter={categoryFilter}
          onCategoryChange={handleCategoryChange}
          showDeletedProducts={showDeletedProducts}
          onToggleDeleted={handleToggleDeleted}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onAddProduct={() => setShowAddModal(true)}
        />

        <div className='product-table'>
          <ProductTable
            products={products}
            categories={categories}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onEdit={handleEditProduct}
            onDelete={handleDeleteProduct}
            showDeletedProducts={showDeletedProducts}
          />
        </div>

        <AddProductModal
          open={showAddModal}
          onClose={handleCloseModals}
          onSubmit={handleAddProduct}
          categories={categories}
          staffMembers={staff}
          businessType={businessType}
        />

        {showEditModal && selectedProduct && (
          <EditProduct
            open={showEditModal}
            product={selectedProduct}
            categories={categories}
            staffMembers={staff}
            businessType={businessType}
            onClose={handleCloseModals}
            onUpdate={refetchProducts}
          />
        )}

        {showDeleteModal && selectedProduct && <DeleteProducts product={selectedProduct} onClose={handleCloseModals} onDelete={refetchProducts} />}
      </div>
      {loading && <LoadingScreen />}
    </div>
  );
};

export default ProductsPage;
